import t from '@localise/translate';

const navigateToClientPosition = () => {
  // Navigate to company location on Google Maps
  const coordinates = t('client.coordinates');

  const lat = coordinates.lat;
  const lng = coordinates.lng;
  const url = `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;

  // open in a new tab
  window.open(url, '_blank');
};

const navigateToClientCompany = () => {
  const companyName = t('client.googleCompanyName');
  const url = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(companyName)}`;

  window.open(url, '_blank');
};

export default { navigateToClientPosition, navigateToClientCompany };
